<template>
  <div class="login">
    <Error v-if="error" :message="error"/>

    <div class="form">
      <div class="header">
        <b>
          {{ $t('login.header') }}
        </b><br> {{ $t('login.subheader') }}
      </div>
      <div class="body">
        <div class="form-item">
          <label for="email">{{$t('login.email')}}</label><br>
          <input type="text" name="email" class="text-input" v-model="username">
        </div>
        <div class="form-item">
          <label for="">{{$t('login.password')}}</label><br>
          <input type="password" name="password" class="text-input" v-model="password">
        </div>
        <div class="forgot">
          <span>
            <router-link :to="{ name: 'PassReset'}" tag="a">
              {{$t('login.forgot')}}
            </router-link>
          </span>
          <button class="btn btn-primary btn-block" @click="handleLogin()">
            {{$t('login.login_btn')}}
          </button>
        </div>
      </div>
      <div class="footer">
        {{$t('login.no_login')}}

        <router-link :to="{ name: 'Register'}" tag="a">
          {{ $t('login.register_now')}}
        </router-link>

      </div>
    </div>
    <Flags/>
  </div>
</template>

<script>
import Flags from './common/Flags'
import Error from './common/Error.vue'
import api from '../api'

export default {
  name: 'Login',
  components: {
    Flags, Error
  },
  data () {
    return {
      username: '',
      password: '',
      error: false
    }
  },
  created () {
    localStorage.removeItem('vuex')
    this.$Progress.finish()
  },
  methods: {
    handleLogin () {
      var self = this
      var username = self.username
      var password = self.password

      self.$Progress.set(25)

      api.postLogin(
        username,
        password
      )
      .then((d) => {
        self.$store.commit('setToken', d.data.access_token)
        self.$Progress.set(50)

        api.getUser()
          .then((r) => {
            self.$store.commit('setUser', r.data)
            self.redirect()
            self.$Progress.finish()
          })
          .catch((e) => {
            self.$Progress.fail()
            self.error = e.response.data.error
          })
      })
      .catch((e) => {
        self.$Progress.fail()
        self.error = e.response.data.message
      })
    },
    redirect () {
      var self = this
      var path = self.$route.query.redirect || null

      if (path) {
        self.$router.push({
          path
        })
      } else {
        self.$router.push('/cockpit')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" src="../styles/_Login.styl"/>



// WEBPACK FOOTER //
// src/components/Login.vue